import * as React from 'react';
// @ts-ignore
import plusIcon from '../../assets/icons/plus.svg';
// @ts-ignore
import minusIcon from '../../assets/icons/minus.svg';
import { INumberInputProps } from './NumberInput.types';
import { onInputChange } from './NumberInput.logic';

const NumberInput: React.FC<INumberInputProps> = (props: INumberInputProps) => {
  const { value, onChange, testId } = props;

  const handleOnInputChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    onInputChange(e, onChange);
  return (
    <div className="number-input" data-testid={testId || 'numberInput'}>
      <button
        className="left"
        type="button"
        onClick={() => onChange(value > 0 ? value - 1 : 0)}
      >
        <img src={minusIcon} alt="minus-icon" />
      </button>
      <input type="text" value={value ?? ''} onChange={handleOnInputChange} />
      <button
        className="right"
        type="button"
        onClick={() => onChange(value >= 0 ? value + 1 : 1)}
      >
        <img src={plusIcon} alt="plus-icon" />
      </button>
    </div>
  );
};

export default NumberInput;
